import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["option", "children", "disallowedUserTooltip", "DisallowedTeamFormattedMessage"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { extractTeamIdFromSelect } from './UsersAndTeamsSearchUtils';
import { View } from 'foundations-components/components/View';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const UsersAndTeamsSearchOptionComponent = _ref => {
  let {
      option,
      children,
      disallowedUserTooltip,
      DisallowedTeamFormattedMessage
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (option.depth) {
    if (option.disabled) {
      return /*#__PURE__*/_jsx(Tooltip, {
        placement: "left",
        title: /*#__PURE__*/_jsx(DisallowedTeamFormattedMessage, {
          teamId: extractTeamIdFromSelect(option.value),
          teamName: option.text
        }),
        children: /*#__PURE__*/_jsx(View, {
          as: "div",
          paddingInlineStart: `${option.depth * 300}`,
          children: children
        })
      });
    }
    return /*#__PURE__*/_jsx(View, {
      as: "div",
      paddingInlineStart: `${option.depth * 300}`,
      children: children
    });
  }
  if (option.isMemberOfSelectedTeam) {
    return /*#__PURE__*/_jsx(Tooltip, {
      placement: "left",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ui-asset-management-lib.tooltips.userSearchTooltip"
      }),
      children: /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
        children: children
      }))
    });
  }
  if (option.isUserDisabled && disallowedUserTooltip) {
    return /*#__PURE__*/_jsx(Tooltip, {
      placement: "left",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: disallowedUserTooltip
      }),
      children: /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
        children: children
      }))
    });
  }
  if (option.disabled) {
    return /*#__PURE__*/_jsx(Tooltip, {
      placement: "left",
      title: /*#__PURE__*/_jsx(DisallowedTeamFormattedMessage, {
        teamId: extractTeamIdFromSelect(option.value),
        teamName: option.text
      }),
      children: /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
        children: children
      }))
    });
  }
  return /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
    children: children
  }));
};
export default UsersAndTeamsSearchOptionComponent;